export interface PricingFilter {
    id: number;
    name: string;
    description: string;
    createdOn: Date;
    createdBy: string;
    modifiedOn: Date;
    modifiedBy: string;
}

export const emptyPricingFilter: PricingFilter = {
    id: null,
    name: '',
    description: '',
    createdOn: null,
    createdBy: '',
    modifiedOn: null,
    modifiedBy: ''
};
